import c from 'classnames';
import { format } from 'date-fns';
import React from 'react';

import { Icon, TextColor, Typography } from '@repo/ui';
import { AgeGroup, getAgeGroup, parseDate } from '@repo/utils';
import { useCurrentKitAndTinyAccount } from 'hooks/useCurrentKitAndTinyAccount';

import background from 'assets/images/summary/first-look/intro_background.svg';
import illustration from 'assets/images/summary/first-look/intro_illustration.svg';

import line1 from 'assets/images/summary/first-look/intro_line_1.svg';
import line2 from 'assets/images/summary/first-look/intro_line_2.svg';
import line3 from 'assets/images/summary/first-look/intro_line_3.svg';

import { SLIDE_BACKGROUND_COLORS } from '../slideBackgroundColors';

import styles from './Intro.module.css';
import slideStyles from './Slides.module.css';

export const Intro: React.FC = () => {
  const { currentKit, currentTinyAccount } = useCurrentKitAndTinyAccount();

  if (!currentKit || !currentTinyAccount) return null;

  const formattedDate = currentKit.sample_date
    ? format(parseDate(currentKit.sample_date), 'MMM d, yyyy')
    : '';

  const ageGroup = getAgeGroup(currentKit.age_at_sampling ?? 0);

  return (
    <div
      className={c(slideStyles.slideWrapper, styles.slideContainer)}
      style={{ backgroundColor: SLIDE_BACKGROUND_COLORS.intro }}
    >
      <div className={styles.contentContainer}>
        <Typography
          variant='heading-2xl'
          color={TextColor.DARKGREEN}
          weight='medium'
        >
          Here's a{' '}
          <Typography
            variant='heading-2xl'
            color={TextColor.DARKORANGE}
            weight='medium'
          >
            first look
          </Typography>{' '}
          at{' '}
          {ageGroup !== AgeGroup.ADULT
            ? `${currentTinyAccount.first_name}'s`
            : 'your'}{' '}
          results
        </Typography>
        <div className={styles.dataContainer}>
          <Icon name='userSingle' size='s' />
          <Typography variant='label'>
            {currentTinyAccount.first_name}
          </Typography>
          <Icon name='circleFilled' size='xs' className={styles.dot} />
          <Icon name='priceTag' size='s' />
          <Typography variant='label'>Kit ID: {currentKit.id}</Typography>
          <Icon name='circleFilled' size='xs' className={styles.dot} />
          <Icon name='calendar' size='s' />
          <Typography variant='label'>{formattedDate}</Typography>
        </div>
        <div className={styles.imagesContainer}>
          <img
            src={background}
            alt='Results background'
            className={styles.backgroundImage}
          />
          <img
            src={illustration}
            alt='Results illustration'
            className={styles.illustrationImage}
          />
        </div>
        <div className={styles.linesContainer}>
          <img src={line1} className={styles.lineImage} />
          <img src={line2} className={styles.lineImage} />
          <img src={line3} className={styles.lineImage} />
        </div>
      </div>
    </div>
  );
};
